import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import EditSuburbs from "../EditSuburbs";
import SuburbsDelete from "./SuburbsDelete";
import CustomTooltip from "../../../common/CustomTooltip";

const SuburbsActionButton = ({ id, suburbsModal }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showSuburbs, setShowSuburbs] = useState(false);

  const toggleSuburbsModal = () => {
    showSuburbs && suburbsModal();

    setShowSuburbs(!showSuburbs);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        {/* <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#clientDetail"
        /> */}
        {/* <span></span>&nbsp;&nbsp;/&nbsp;&nbsp; */}
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={toggleSuburbsModal}
            />
          </span>
        </CustomTooltip>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <CustomTooltip message={"Delete"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleDeleteModal}
              icon={faTrash}
              size="1x"
              data-toggle="modal"
              data-target="#deleteClient"
            />
          </span>
        </CustomTooltip>
      </span>

      {showDelete && (
        <SuburbsDelete
          suburbsId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={suburbsModal}
          showDelete={showDelete}
        />
      )}

      {showSuburbs && (
        <EditSuburbs
          suburbsId={id}
          showSuburbs={showSuburbs}
          toggleSuburbsModal={toggleSuburbsModal}
        />
      )}

      {/* {showView && (
        <SuburbsDetailPopup
          showView={showView}
          suburbsId={id}
          toggleShowModal={toggleShowModal}
        />
      )} */}
    </>
  );
};

export default SuburbsActionButton;
